module.exports = __webpack_public_path__ + "static/media/icon-fleet-wheel.fa8a5d5b.svg";